import React from "react";
import { useSelector } from "react-redux";
// import { fixImagePaths } from "../../../components/util";
import FooterBottom from "./FooterBottom";
// import Newsletter from "../../Common/Newsletter";
import { decodeHtml } from "../../util";

const Footer = ({ footerClass }) => {
  const { page } = useSelector((state) => state.data);

  // if (!page || !page.data) {
  //   return <Loader />;
  // }

  const htmlContent = decodeHtml(page.data["footer"]?.htmlContent || "");

  return (
    <footer id="extraP" className={footerClass ? footerClass : "rs-footer"}>
      {htmlContent && <div dangerouslySetInnerHTML={{ __html: htmlContent }} />}
      <FooterBottom />
    </footer>
  );
};

export default Footer;
